document.addEventListener("DOMContentLoaded", () => {
    const wrapper_btn_catalog = document.querySelector('.js-open-catalog');
    const menu_catalog = document.querySelector('.js-menu-catalog');
    const searchToggle = document.querySelector('.main-menu__search-toggle');
    const searchPanel = document.getElementById('header-search-panel');
    const catalogButton = wrapper_btn_catalog && wrapper_btn_catalog.querySelector('.js-btn-catalog');

    const closeSearch = (restoreFocus = false) => {
        if (!searchPanel || searchPanel.hidden) return;
        searchPanel.hidden = true;
        searchToggle.setAttribute('aria-expanded', 'false');
        searchToggle.setAttribute('aria-label', 'Открыть поиск по сайту');
        const searchContainer = searchPanel.querySelector('.bx-searchtitle');
        if (searchContainer) searchContainer.dispatchEvent(new Event('header-search-close'));
        if (restoreFocus) searchToggle.focus();
    };

    if (searchToggle && searchPanel) {
        searchToggle.addEventListener('click', () => {
            if (!searchPanel.hidden) {
                closeSearch(true);
                return;
            }
            if (menu_catalog) menu_catalog.classList.remove('active');
            if (catalogButton) catalogButton.classList.remove('active');
            searchPanel.hidden = false;
            searchToggle.setAttribute('aria-expanded', 'true');
            searchToggle.setAttribute('aria-label', 'Закрыть поиск по сайту');
            const input = searchPanel.querySelector('input[name="q"]');
            if (input) input.focus();
        });
        searchPanel.querySelector('.header-search__close').addEventListener('click', () => closeSearch(true));
        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && !searchPanel.hidden) {
                event.preventDefault();
                closeSearch(true);
            }
        });
        document.addEventListener('click', (event) => {
            if (!searchPanel.contains(event.target) && !searchToggle.contains(event.target)
                && !event.target.closest('[data-header-search-results]')) closeSearch();
        });
        const mobileViewport = window.matchMedia('(max-width: 991.9px)');
        mobileViewport.addEventListener('change', (event) => {
            if (event.matches) closeSearch();
        });
    }

    if (wrapper_btn_catalog && menu_catalog) {
        const btn_catalog = wrapper_btn_catalog.querySelector('.js-btn-catalog');
        if(btn_catalog){
            wrapper_btn_catalog.addEventListener('mouseover', () => {
                closeSearch();
                menu_catalog.classList.add('active');
                btn_catalog.classList.add('active');
            });

            wrapper_btn_catalog.addEventListener('mouseleave', (event) => {
                // Проверяем, переместился ли курсор на menu_catalog или его дочерние элементы
                if (!(menu_catalog.contains(event.relatedTarget))) {
                    menu_catalog.classList.remove('active');
                    btn_catalog.classList.remove('active');
                }
            });

            menu_catalog.addEventListener('mouseleave', (event) => {
                // Проверяем, переместился ли курсор за пределы menu_catalog и wrapper_btn_catalog
                if (!(wrapper_btn_catalog.contains(event.relatedTarget))) {
                    menu_catalog.classList.remove('active');
                    btn_catalog.classList.remove('active');
                }
            });
        }
    }
});
